module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kg-La.51476bc2.png";